import { getPasswordChecks } from "@/lib/passwordPolicy";

export const PasswordRequirements = ({ password }) => {
  if (!password) return null;
  const checks = getPasswordChecks(password);
  return (
    <ul className="list-unstyled mt-1 mb-0" style={{ fontSize: "0.82rem" }}>
      {checks.map((c, i) => (
        <li key={i} style={{ color: c.ok ? "#4caf50" : "#e53935" }}>
          {c.ok ? "✔" : "✖"} {c.label}
        </li>
      ))}
    </ul>
  );
};
